import { Tooltip, ActionIcon, Text } from "@mantine/core"
import { modals } from "@mantine/modals"
import { IconTrash } from "@tabler/icons-react"
import { type Article } from "../../shared/types/article"
import { ArticleStore } from "../../app/store"
import { observer } from "mobx-react-lite"

// ----------------------------------------------------------------------

export const ArticleDeleteModal = observer(function ArticleDeleteModal(article: Article) {
  const { title, _id } = article

  const openDeleteModal = () =>
    modals.openConfirmModal({
      zIndex: 1001,
      title: "Удаление статьи",
      centered: true,
      children: <Text size="sm">{`Вы уверены, что хотите удалить статью "${title}"?`}</Text>,
      labels: { confirm: "Подтвердить", cancel: "Отмена" },
      confirmProps: { color: "red" },
      onConfirm: () => void ArticleStore.removeArticle(_id),
    })

  return (
    <Tooltip label="Удалить статью">
      <ActionIcon color="red" onClick={openDeleteModal} radius="xl" size="xl">
        <IconTrash stroke={1.5}/>
      </ActionIcon>
    </Tooltip>
  )
})
